import React, { Component } from 'react';
import { Form, Table } from 'antd';
import { Link } from 'react-router';

import moment from 'moment';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    return [
      {
        title: '合同编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => (
          <Link to={`/incubator/oregistapp_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '客户',
        dataIndex: 'custom',
        key: 'custom',
        width: 200,
        render: (text, record) => (
          <span>
            {record.custom}
            {record.projectName ? `(${record.projectName})` : ''}
          </span>
        ),
      },
      {
        title: '入驻园区',
        dataIndex: 'incubator',
        key: 'incubator',
        width: 200,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '当前环节',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.name || ''}</span>;
        },
      },
      {
        title: '当前处理人',
        dataIndex: 'processorName',
        key: 'processorName',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.processorName || ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          let element;
          if (instance.status === 1) {
            element = <span style={{ color: 'red' }}>已完成</span>;
          } else {
            element = record.instance ? <span>处理中</span> : <span>待编辑</span>;
          }
          return element;
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        rowKey="uuid"
        loading={loading}
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/oregistapp/TableSettled.js